<form #form="ngForm" novalidate>
    <ng-template [ngIf]="entity">
        <div class="row">
            <div class="form-group col-12" [class.col-md-3]="!isMini">
                <label for="contatoTipo" class="col-form-label">Tipo</label>

                <ng-template [ngIf]="isContatoTipoPrimario()">
                    <input type="text" class="form-control" [value]="entity.tipo | pessoaContatoTipo" disabled="disabled" readonly="readonly">
                </ng-template>
                <ng-template [ngIf]="!isContatoTipoPrimario()">
                    <select class="form-control" name="contatoTipo" id="contatoTipo"
                        [ngModel]="entity.tipo || ''" (ngModelChange)="entity.tipo = $event ? $event : null"
                        #contatoTipo="ngModel" #contatoTipoSelect required="required" >
                        <option value="">Selecione o tipo do contato...</option>
                        <option *ngFor="let tipo of tipos" [ngValue]="tipo.id">{{tipo.nome}}</option>
                    </select>
                    <sgt-form-control-error
                        *ngIf="contatoTipo.errors && contatoTipo.errors.required && contatoTipo.dirty"
                        msgError="O tipo do contato é obrigatório">
                    </sgt-form-control-error>
                </ng-template>                
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                 <label for="contatoNome" class="col-form-label">Nome</label>
                 <input type="text" class="form-control" [(ngModel)]="entity.nome" name="contatoNome" id="contatoNome"
                    #contatoNome="ngModel" #contatoNomeInput maxlength="255" sgtUppercase>
                <sgt-form-control-error
                    *ngIf="contatoNome.errors && contatoNome.errors.maxlength"
                    msgError="O nome deve ter no máximo 255 caracteres">
                </sgt-form-control-error>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12" [class.col-md-3]="!isMini">
                <label for="contatoFone" class="col-form-label">Telefone</label>
                <input type="tel" class="form-control" [(ngModel)]="entity.fone" name="contatoFone" id="contatoFone"
                    #contatoFone="ngModel" sgtFone>
                <p style="margin-bottom:0px;" class="form-text text-muted">Caso o cliente possua somente celular, informe aqui também o celular.</p>
                <sgt-form-control-error
                    *ngIf="contatoFone.errors && contatoFone.errors.foneInvalido"
                    msgError="O telefone deve ter no míninio 10 dígitos com o DDD">
                </sgt-form-control-error>
            </div>
            <div class="form-group col-12" [class.col-md-3]="!isMini">
                <label for="contatoCelular" class="col-form-label">Celular</label>
                <input type="tel" class="form-control" [(ngModel)]="entity.celular" name="contatoCelular" id="contatoCelular"
                    #contatoCelular="ngModel" sgtFone>
                <sgt-form-control-error
                    *ngIf="contatoCelular.errors && contatoCelular.errors.foneInvalido"
                    msgError="O celular deve ter no míninio 10 dígitos com o DDD">
                </sgt-form-control-error>
            </div>
            <div class="form-group col-12" [class.col-md-6]="!isMini">
                <label for="contatoEmail" class="col-form-label">E-mail</label>
                <input type="email" class="form-control" [(ngModel)]="entity.email" name="contatoEmail" id="contatoEmail"
                    #contatoEmail="ngModel" maxlength="100" sgtLowercase>
                <sgt-form-control-error
                    *ngIf="contatoEmail.errors && contatoEmail.errors.maxlength"
                    msgError="O e-mail deve ter no máximo 100 caracteres">
                </sgt-form-control-error>
            </div>
        </div>
        <div class="row">
             <div class="form-group col-12">
                 <label for="contatoAnotacao" class="col-form-label">Anotação</label>
                 <textarea class="form-control" [(ngModel)]="entity.anotacao" name="contatoAnotacao" id="contatoAnotacao"
                     #contatoAnotacao="ngModel" maxlength="500" rows="5" sgtUppercase>
                </textarea>
                <sgt-form-control-error
                    *ngIf="contatoAnotacao.errors && contatoAnotacao.errors.maxlength"
                    msgError="A anotação deve ter no máximo 500 caracteres">
                </sgt-form-control-error>
             </div>
        </div>
    </ng-template>
</form>
